var _path, _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 53,
    viewBox: "0 0 52 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.0004 5.28662L26.7075 4.57951L26.0004 3.87241L25.2933 4.57951L26.0004 5.28662ZM46.5065 27.2069L47.2136 27.914L48.6278 26.4998L47.9207 25.7927L46.5065 27.2069ZM26.0004 47.713L25.2933 48.4201L25.9995 49.1264L26.7066 48.421L26.0004 47.713ZM4.78722 26.4998L4.08011 25.7927L3.373 26.4998L4.08011 27.2069L4.78722 26.4998ZM25.2933 5.99373L46.5065 27.2069L47.9207 25.7927L26.7075 4.57951L25.2933 5.99373ZM26.7075 47.0059L5.49432 25.7927L4.08011 27.2069L25.2933 48.4201L26.7075 47.0059ZM5.49432 27.2069L26.7075 5.99373L25.2933 4.57951L4.08011 25.7927L5.49432 27.2069ZM44.4705 27.8761L25.2942 47.005L26.7066 48.421L45.883 29.2921L44.4705 27.8761Z",
    fill: "#CCCCCC"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 26.7783,
    width: 2,
    height: 10,
    transform: "rotate(180 27 26.7783)",
    fill: "#CCCCCC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 27.25,
    y: 31.2783,
    width: 2.5,
    height: 2.5,
    transform: "rotate(180 27.25 31.2783)",
    fill: "#CCCCCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.039e05f8b35d87f11ed4f0b7394cfa88.svg";
export { ForwardRef as ReactComponent };